
import { Component, Vue, Prop } from 'vue-property-decorator';
import { getEngineerList, getWorkUser } from '@/api/users';
import { getDepartmentList } from '@/api/company';
import { UserModule } from '@/store/modules/user';
import { checkTaskCoordinationVisble } from '@/utils/permission';
import { Type } from '@/types/permissionType';
import { getService } from '@/api/service';
import { assignOrders, transferOrders } from '@/api/orderService';

@Component({
  name: 'OrderProcessDialog',
  components: {

  }
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  selectedOrderProcessVisible!: Boolean;

  @Prop({
    type: String,
    default: '2'
  })
  OrderProcessType!: String;

  @Prop({
    type: Object,
    default: () => {}
  })
  orderDetail!: any;

  @Prop({
    type: Array,
    default: () => []
  })
  orderList!: any;
  @Prop({
    type: Array,
    default: () => []
  })
  dealList!: any;

  // private dealList:any=[]

  private radioWay = 0
  private searchDept: any = {
    name: ''
  }
  private deptLoading = false;
  private deptTableData: any = []
  private page:number=1;
  private pageCount:number=1;
  private selectedData:any = {}

  // 人员
  private formSearch: any = {
    name: '',
    dept: ''
  };
  private engList:any = [];
  private listLoading = false;
  private engPage:number=1
  private engPageCount:number=1;

  private selectedUserData:any={}
  private selectedUserDataList:any=[];
  private selectedUserIdDataList:any=[];

  private isUntreatedAscending:number = 0
  private isUnderwayAscending:number = 0
  private geocoder:any=''

  private taskCoordinationDisabled=false;
  private taskCoordinationVisble=false;
  private taskCoordination:any = ''

  private depttype:any='9';
  private loading:boolean=false;

  created() {
    if (this.orderDetail && this.orderDetail.order && this.orderDetail.order_service && this.OrderProcessType !== '2') {
      this.taskCoordinationDisabled = parseInt(this.orderDetail.order_service.is_assign_other_task_complete) === 1 || parseInt(this.orderDetail.order_service.state) > 220
      this.taskCoordinationVisble = checkTaskCoordinationVisble(this.orderDetail.order.order_type, this.orderDetail.order_service.servicer_company_id)
      this.taskCoordination = parseInt(this.orderDetail.order_service.is_assign_other_task_complete) === 1;

      if (this.dealList[0].show) {
        this.radioWay = 1
        if (UserModule.getUserDeptList) {
          this.deptTableData = UserModule.getUserDeptList.filter((bean:any) => {
            return parseInt(bean.dept_type) === 2;
          });
          if (this.deptTableData && this.deptTableData.length === 1) {
            this.selectedData = this.deptTableData[0]
          }
        }
      } else if (this.dealList[1].show) {
        this.radioWay = 3
        this.depttype = 2;
        this.getDeptList()
      } else if (this.dealList[2].show) {
        this.radioWay = 2
        this.depttype = 9;
        this.getDeptList()
      } else if (this.dealList[3].show) {
        this.radioWay = 4;
      } else {
        this.radioWay = 5;
        this.depttype = 2;
        this.getDeptList()
      }
    } else {
      this.depttype = 9;
      this.getDeptList();
    }
    this.geocoder = new AMap.Geocoder();
  }
  private radioWayHandle() {
    switch (this.radioWay) {
      case 1:
        this.selectedData = {}
        if (UserModule.getUserDeptList) {
          this.deptTableData = UserModule.getUserDeptList.filter((bean:any) => {
            return parseInt(bean.dept_type) === 2;
          });
          if (this.deptTableData && this.deptTableData.length === 1) {
            this.selectedData = this.deptTableData[0]
          }
        } else {
          this.deptTableData = []
        }
        break
      case 2:
        this.selectedData = {};
        this.depttype = 9;
        this.getDeptList()
        break
      case 3:
        this.engList = [];
        this.selectedData = {}
        this.depttype = 2;
        this.getDeptList()
        break
      case 4:
        break
      case 5:
        this.selectedData = {}
        this.engList = [];
        this.depttype = 2;
        this.getDeptList()
        break
    }
    console.log(this.radioWay, this.engList)
  }
  private search() {
    if (!this.selectedData.id) {
      this.showErrorMsg("请选择部门");
      return;
    }
    this.getEngineerList();
  }
  private serviceList: any = [];
  private service:any={}

  private getService() {
    const params: any = {
      user_id: UserModule.getUserId,
      company_id: this.orderDetail.order_service.servicer_company_id,
      page: 1,
      size: 100
    };
    getService(params)
      .then((res: any) => {
        if (res.data) {
          this.serviceList = res.data.list;
        }
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  // private rest() {
  //   this.formSearch.name = '';
  //   // this.formSearch.dept = '';
  //   if (!this.selectedData.id) {
  //     this.showErrorMsg("请选择部门");
  //     return;
  //   }
  //   this.getEngineerList();
  // }
  private getEngineerList() {
    this.listLoading = true;
    let that = this;
    const params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      engineer: this.formSearch.name,
      department_id: this.selectedData.id,
      // department_name: this.formSearch.dept,
      page: this.engPage,
      size: 20,
    };
    if (that.isUntreatedAscending === 1) {
      params.untreated = 'asc';
    } else if (that.isUntreatedAscending === 2) {
      params.untreated = 'desc';
    }
    if (that.isUnderwayAscending === 1) {
      params.hand = 'asc';
    } else if (that.isUnderwayAscending === 2) {
      params.hand = 'desc';
    }
    getEngineerList(params)
      .then((res) => {
        const data = res.data;
        if (data !== null) {
          this.engPageCount = data.page_count;
          if (this.engPage === 1) {
            this.engList = this.dealData(data.list);
          } else {
            this.engList = this.engList.concat(this.dealData(data.list))
          }
          this.engList.forEach((element:any) => {
            if (element.longitude && element.latitude) {
              this.geocoder.getAddress(
                new AMap.LngLat(element.longitude, element.latitude),
                function(status: string, result: { regeocode: { formattedAddress: string; }; }) {
                  if (status === 'complete' && result.regeocode) {
                    element.address = result.regeocode.formattedAddress;
                  }
                }
              );
            }
          });
        } else {
          this.engPageCount = 0;
          this.engList = [];
        }
        this.listLoading = false;
      })
      .catch((err) => {
        this.engPageCount = 0;
        this.engList = [];
        this.listLoading = false;
        let msg = err.msg;
      });
  }
  private getWorkUser() {
    const params: any = {
      dept_name: this.selectedData.name,
      dept_id: this.selectedData.id,
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      page: this.engPage,
      size: 10
    };
    if (this.orderDetail.order) {
      params.order_id = this.orderDetail.order.id;
    }
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    getWorkUser(params)
      .then((res: any) => {
        if (res.data) {
          if (this.engPage === 1) {
            this.engList = res.data.list;
          } else {
            this.engList = this.engList.concat(res.data.list);
          }
          this.engPageCount = res.data.page_count;
        } else {
          if (this.engPage === 1) {
            this.engList = [];
            this.engPageCount = 1;
          }
        }
      })
      .catch((err: any) => {
        if (this.engPage === 1) {
          this.engList = [];
          this.engPageCount = 1;
        }
        let msg = err.msg;
      });
  }
  private dealData(val:any) {
    for (var i = 0; i < val.length; i++) {
      if (val[i].dept_list.length > 0) {
        var temp = '';
        for (var j = 0; j < val[i].dept_list.length; j++) {
          temp += (val[i].dept_list[j] as any).name + '、';
        }
        if (temp.endsWith('、')) {
          temp = temp.substring(0, temp.length - 1);
        }
        val[i].dept_str = temp;
      }
    }
    return val;
  }
  private engMore() {
    this.engPage = this.engPage + 1
    if (this.radioWay === 0) {
      this.getEngineerList();
    } else if (this.radioWay === 3 || this.radioWay === 5) {
      this.getWorkUser();
    }
  }
  private untreatedUp() {
    this.isUntreatedAscending = 1;
    this.isUnderwayAscending = 0;
    this.getEngineerList();
  }
  private untreatedDown() {
    this.isUntreatedAscending = 2;
    this.isUnderwayAscending = 0;
    this.getEngineerList();
  }
  private underwaydUp() {
    this.isUnderwayAscending = 1;
    this.isUntreatedAscending = 0;
    this.getEngineerList();
  }
  private underwaydDown() {
    this.isUnderwayAscending = 2;
    this.isUntreatedAscending = 0;
    this.getEngineerList();
  }
  private selectedEngChange(val: any) {
    if (this.selectedUserData === val) {
      this.selectedUserData = {};
    } else {
      this.selectedUserData = val;
    }
  }
  private selectedUserChange(s:boolean, val:any) {
    if (s) {
      this.selectedUserDataList.push(val)
    } else {
      let index = this.selectedUserDataList.indexOf(val);
      this.selectedUserDataList.splice(index, 1)
    }
  }

  // 部门

  private getDeptList() {
    this.deptLoading = true;
    let params: any = {
      page: this.page,
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      type: this.depttype, // 部门类型 1报修部门 2服务部门 3审批部门 9所有部门 (必填)
      dept_type: 2 // 部门类型 1报修部门 2服务部门
    };
    if (this.searchDept.name) {
      params.name = this.searchDept.name;
    }
    if (this.orderDetail && this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    // if (this.tableData) {
    //   let serviceIDs: any = '';
    //   for (const item of this.tableData) {
    //     serviceIDs = serviceIDs + item.order_service.id + ',';
    //   }
    //   params.order_service_id = serviceIDs.substring(0, serviceIDs.length - 1);
    // }

    if (this.orderDetail && this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    getDepartmentList(params)
      .then((res) => {
        if (res.data) {
          this.pageCount = res.data.page_count;
          if (this.page === 1) {
            this.deptTableData = res.data.list;
          } else {
            this.deptTableData = this.deptTableData.concat(res.data.list);
          }
        } else {
          if (this.page === 1) {
            this.deptTableData = [];
          }
        }
        // this.setDept(this.deptTableData);
        this.deptLoading = false;
      })
      .catch((err) => {
        if (this.page === 1) {
          this.deptTableData = [];
        }
        this.deptLoading = false;
        let msg = err.msg;
      });
  }
  private selectedDeptChange(val: any) {
    this.engPage = 1;
    this.selectedUserData = {};
    if (this.radioWay === 0) {
      this.getEngineerList();
    } else if (this.radioWay === 3 || this.radioWay === 5) {
      this.getWorkUser();
    }
  }
  private searchHandle() {
    this.page = 1;
    this.getDeptList();
  }

  private confirmHandle() {
    if (this.OrderProcessType === '2') {
      if (this.deptTableData && this.deptTableData.length > 0 && !this.selectedData.id && !this.selectedData.name) {
        this.showErrorMsg("请选择部门");
        return;
      }
      if (!this.selectedUserData.user_id) {
        this.showErrorMsg("请选择人员");
        return;
      }
      this.$emit('selectedOrderProcessData', this.selectedUserData, this.selectedData)
      this.close(true)
    } else {
      if (this.radioWay === 4) {
        if (parseInt(this.orderDetail.order_service.order_task_count) > 0) {
          this.showErrorMsg("已指派工程师,不能转单");
          return;
        }
        if (this.orderDetail.order.parts_list && this.orderDetail.order.parts_list.length > 0) {
          this.showErrorMsg("已添加备件,可删除后转单");
          return;
        }
        if (this.orderDetail.order_service.device_list && this.orderDetail.order_service.device_list.length > 0) {
          this.showErrorMsg("已添加设备,可删除后转单");
          return;
        }
        if (this.orderDetail.order.order_price && this.orderDetail.order.order_price.length > 0) {
          this.showErrorMsg("已添加费用,可删除后转单");
          return;
        }
        if (this.orderDetail.order.fault_list && this.orderDetail.order.fault_list.length > 0) {
          this.showErrorMsg("已添加故障类型,可删除后转单");
          return;
        }
        if (!(this.service && this.service.id)) {
          this.showErrorMsg("请选择服务方");
          return;
        }
      } else {
        if (this.deptTableData && this.deptTableData.length > 0 && !this.selectedData.id && !this.selectedData.name) {
          this.showErrorMsg("请选择部门");
          return;
        }
        if ((this.radioWay === 3 || this.radioWay === 5) && !(this.selectedUserDataList && this.selectedUserDataList.length > 0)) {
          this.showErrorMsg("请选择人员");
          return;
        }
      }
      if (this.OrderProcessType === '3') {
        // 批量处理
        this.dealOrder();
      } else {
        this.$emit('selectedOrderProcessData', this.radioWay, this.selectedUserDataList, this.selectedData, this.service, this.taskCoordinationVisble, this.taskCoordination)
      }
    }
  }
  private dealOrder() {
    let params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: (this.orderDetail && this.orderDetail.order_service) ? this.orderDetail.order_service.servicer_company_id : UserModule.getCompanyId
    };
    let serviceIDs: any = [];
    for (const item of this.orderList) {
      serviceIDs.push(item.order_service.id);
    }
    params.order_service_id = JSON.stringify(serviceIDs);
    params.is_new_home = '1'; // 新后台处理标识 因为同样的接口字段work_user APP使用map(先选人后选单-工程师派单)  新后台用list(既有先选人后选单-工程师派单  也有先选单后选人-批量处理订单)
    if (this.radioWay === 5) {
        params.is_assign_enquiry = '1'
      }
    switch (this.radioWay) {
      case 1:
        if (this.deptTableData && this.deptTableData.length > 0) {
          if (!this.selectedData || !this.selectedData.id) {
            this.showErrorMsg('请选择部门');
            return;
          }
        }
        var workUser:any = {
          user_id: UserModule.getUserId,
          user_name: UserModule.getUserName
        };
        if (this.selectedData.id) {
          workUser.dept_id = this.selectedData.id;
          workUser.dept_name = this.selectedData.name;
        }
        var arr:any = [];
        arr.push(workUser);
        params.work_user = JSON.stringify(arr);

        break
      case 2:
        if (!this.selectedData.id) {
          this.showErrorMsg('请选择部门');
          return;
        }
        params.work_department_id = this.selectedData.id;
        params.work_department_name = this.selectedData.name;
        break
      case 3:
      case 5:
        if (!this.selectedData.id && !this.selectedData.name) {
          this.showErrorMsg('请选择部门');
          return;
        }
        if (!this.selectedUserDataList || this.selectedUserDataList.length <= 0) {
          this.showErrorMsg('请选择工程师');
          return;
        }
        var userList: any = [];
        for (const assign of this.selectedUserDataList) {
          let assingBean = {
            user_id: assign.user.user_id,
            name: assign.user.name,
            dept_id: assign.dept_id ? assign.dept_id : '',
            dept_name: assign.dept_id ? assign.dept_name : ''
          };
          userList.push(assingBean);
        }
        params.work_user = JSON.stringify(userList);

        break
      case 4:
        params.transfer_company_id = this.service.servicer_company_id;
        params.transfer_company_name = this.service.name;
        break
    }
    this.loading = true;
    if (this.radioWay === 4) {
      transferOrders(params)
        .then((res: any) => {
          this.loading = false;
          this.showSecussMsg(res.msg);
          this.close(true)
        })
        .catch((err: any) => {
          this.loading = false;
          this.showErrorMsg(err.msg);
        });
    } else {
      assignOrders(params)
        .then((res: any) => {
          this.loading = false;
          this.showSecussMsg(res.msg);
          this.close(true)
        })
        .catch((err: any) => {
          this.loading = false;
          this.showErrorMsg(err.msg);
        });
    }
  }

  private delSelectedHandle(val: any) {
    let index = this.selectedUserDataList.indexOf(val);
    this.selectedUserDataList.splice(index, 1);
    this.selectedUserIdDataList.splice(index, 1);
  }

  private close(isReferesh:any) {
    this.$emit('close', false, isReferesh);
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "error",
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "success",
    });
  }
}
